/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const thirdPartyIconStyles = css({
	marginTop: `${token('space.150', '12px')}`,
	marginBottom: `${token('space.200', '16px')}`,
});

export const GoogleDriveSvg = () => {
	return (
		<svg
			css={thirdPartyIconStyles}
			width="107"
			height="97"
			viewBox="0 0 107 97"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="64" height="64" transform="translate(20 16)" fill="white" fillOpacity="0.01" />
			<rect width="64" height="64" transform="translate(20 16)" fill="white" fillOpacity="0.01" />
			<g clipPath="url(#clip0_206_1000)">
				<path
					d="M8.06415 83.3619L12.7682 91.4871C13.7457 93.1977 15.1508 94.5417 16.8003 95.5192L33.6006 66.4394H0C0 68.3332 0.488736 70.2271 1.46621 71.9377L8.06415 83.3619Z"
					fill="#0066DA"
				/>
				<path
					d="M53.3333 32.2282L36.533 3.14838C34.8835 4.12585 33.4784 5.46987 32.501 7.18045L1.46621 60.9414C0.506713 62.6151 0.00127751 64.5105 0 66.4397H33.6006L53.3333 32.2282Z"
					fill="#00AC47"
				/>
				<path
					d="M89.866 95.5192C91.5155 94.5417 92.9206 93.1977 93.8981 91.4871L95.853 88.1271L105.2 71.9377C106.178 70.2271 106.666 68.3332 106.666 66.4394H73.0632L80.2134 80.4906L89.866 95.5192Z"
					fill="#EA4335"
				/>
				<path
					d="M53.3335 32.2279L70.1338 3.14809C68.4843 2.17062 66.5905 1.68188 64.6355 1.68188H42.0315C40.0765 1.68188 38.1827 2.23171 36.5332 3.14809L53.3335 32.2279Z"
					fill="#00832D"
				/>
				<path
					d="M73.0658 66.4394H33.6004L16.8 95.5192C18.4495 96.4967 20.3434 96.9854 22.2983 96.9854H84.3678C86.3228 96.9854 88.2166 96.4356 89.8661 95.5192L73.0658 66.4394Z"
					fill="#2684FC"
				/>
				<path
					d="M89.683 34.0609L74.1656 7.18045C73.1882 5.46987 71.783 4.12585 70.1336 3.14838L53.3333 32.2282L73.066 66.4397H106.605C106.605 64.5459 106.117 62.652 105.139 60.9414L89.683 34.0609Z"
					fill="#FFBA00"
				/>
			</g>
			<defs>
				<clipPath id="clip0_206_1000">
					<rect width="106.667" height="95.3036" fill="white" transform="translate(0 1.68195)" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const OneDriveSvg = () => {
	return (
		<svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M39.4555 36.8091L39.4562 36.8066L54.5709 45.8601L63.5775 42.07C65.4077 41.2788 67.3811 40.8731 69.375 40.875C69.7072 40.875 70.0356 40.8901 70.3623 40.9119C69.2794 36.6896 66.9935 32.8727 63.7823 29.925C60.5711 26.9773 56.5729 25.0258 52.2735 24.3076C47.9742 23.5894 43.5587 24.1354 39.5638 25.8792C35.5689 27.6231 32.1665 30.4897 29.77 34.1308C29.847 34.1299 29.9228 34.125 30 34.125C33.3405 34.1205 36.6156 35.0502 39.4555 36.8091Z"
				fill="#0364B8"
			/>
			<path
				d="M39.4562 36.8066L39.4555 36.8091C36.6156 35.0502 33.3405 34.1205 30 34.125C29.9228 34.125 29.8469 34.1299 29.77 34.1308C26.5005 34.1713 23.3039 35.102 20.5236 36.8227C17.7433 38.5435 15.4845 40.9894 13.9898 43.8975C12.4952 46.8056 11.8213 50.066 12.0405 53.3284C12.2597 56.5908 13.3637 59.7317 15.234 62.4138L28.563 56.8047L34.4882 54.3113L47.6811 48.7595L54.5709 45.8602L39.4562 36.8066Z"
				fill="#0078D4"
			/>
			<path
				d="M70.3623 40.9119C70.0356 40.8901 69.7072 40.875 69.375 40.875C67.3811 40.8731 65.4081 41.2803 63.5779 42.0715L54.5709 45.8602L57.1827 47.4245L65.7437 52.5525L69.4789 54.7899L82.2507 62.44C83.4112 60.2857 84.0126 57.8746 83.9998 55.4276C83.987 52.9806 83.3605 50.5759 82.1775 48.4338C80.9946 46.2917 79.2931 44.4807 77.2289 43.1665C75.1647 41.8524 72.8037 41.0772 70.3623 40.9119Z"
				fill="#1490DF"
			/>
			<path
				d="M69.479 54.7898L65.7438 52.5525L57.1827 47.4245L54.5709 45.8601L47.6811 48.7594L34.4882 54.3112L28.563 56.8046L15.234 62.4137C16.8904 64.7951 19.0985 66.7403 21.6698 68.0831C24.2411 69.426 27.0992 70.1265 30 70.125H69.375C72.0151 70.1258 74.6061 69.4118 76.873 68.0587C79.14 66.7056 80.9983 64.764 82.2507 62.44L69.479 54.7898Z"
				fill="#28A8EA"
			/>
		</svg>
	);
};
